import styled, { keyframes } from 'styled-components'
import { darken, rgba } from 'polished'
import { fadeIn } from '../FadeIn'

const spinner = keyframes`
  to {
    transform: rotate(360deg);
  }
`

const defaultSize = 40

export const Spinner = styled.div<{ size?: number }>`
  position: relative;
  min-width: ${props => props.size}px;
  height: ${props => props.size}px;
  ${fadeIn()}

  &::before {
    content: '';
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 50%;
    width: ${props => props.size ?? defaultSize}px;
    height: ${props => props.size ?? defaultSize}px;
    margin-top: ${props => parseInt(`${(props.size ?? defaultSize) / 2}`, 10) * (-1)}px;
    margin-left: ${props => parseInt(`${(props.size ?? defaultSize)/ 2}`, 10) * (-1)}px;
    border-radius: 50%;
    border: 1px solid ${props => rgba(props.theme.palette.general.greyLight, 0.5)};
    border-top-color: ${props => darken(0.2, props.theme.palette.primary.alpha)};
    animation: ${spinner} 0.5s linear infinite;
  }
`
